import React from 'react'
import useSWRImmutable from 'swr/immutable'

import Loading from '../../components/layout/Loading'
import SelectInput from '../../components/form/SelectInput'
import { useI18N } from '../../../libraries/i18n/hook'
import { getAllEventTypes } from '../../../api/events'

type Props = {
  onChange: (values: { typeIds: string[] }) => void,
  values?: string[]
}
const TypeSelectBox: React.FC<Props> = ({ values, onChange }) => {
  const { t } = useI18N()
  const { data, isLoading } = useSWRImmutable('event/types', getAllEventTypes)

  const handleChange = (ids: string[]) => {
    onChange({ typeIds: ids })
  }

  if(isLoading) return <Loading />
  const options = data?.map(({ name, id }) => ({ label: name, value: id.toString() }))
  if(!options) return null
  return (
    <SelectInput
      isDisabled={options?.length === 0}
      value={options?.filter((type) => values?.includes(type.value))}
      name='types'
      label={t('common.type')}
      onChange={handleChange}
      options={options}
    />
  )
}

export default TypeSelectBox
